import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {TabsPure, media} from '@modifi/ui'
import {airBlueLight, backgroundColor as grayLighter, mediumGray, white} from '@modifi/colors'

import {defaultTopPadding, defaultBottomPadding} from './constants'

export const colorMap: Record<string, string> = {
  'gray-light': grayLighter,
  'air-blue-light': airBlueLight,
  white,
}

type DefaultComponentWrapperProps = {
  backgroundColor?: string
  padding?: number
}

export const DefaultComponentWrapper = styled.div<DefaultComponentWrapperProps>`
  padding: ${({padding}): string =>
      padding !== undefined
        ? `${padding}px`
        : `${defaultTopPadding}px 0 ${defaultBottomPadding}px;`}
    ${({backgroundColor}): FlattenSimpleInterpolation | string =>
      backgroundColor && colorMap?.[backgroundColor]
        ? css`
            background-color: ${colorMap?.[backgroundColor]};
          `
        : ''};
`

export const StyledTabsPure = styled(TabsPure)`
  flex-direction: row;
  border-bottom: 1px solid ${mediumGray};

  button {
    font-size: 16px;
    margin: 0 16px;
    font-weight: 700;
    ${media.md`
      font-size: 24px;
    `}
  }

  button:not(:first-child) {
    ${media.xs`
      margin-left: 20px;
    `}
  }

  button::after {
    width: calc(100% + 2 * 16px);
    height: 7px;
    left: -16px;
  }
`
